import React, { Component } from "react";
import Navbar from "../navbar/navbar";
import "../home/home.css";
import "./callforpaper.css";
import { List } from "reactstrap";
import callforpaper from "./callforpaper.json";
import instructions from "./instructions.json";
import { LinkButton2 } from "../button/button";
class CallForPapers extends Component {
	render() {
		return (
			<>
				<div className="header-area">
					<div id="home" className="contact-header-area  bg_cover">
						<Navbar />
						<div className=" d-flex align-items-center">
							<div className="container">
								<div className="row justify-content-center">
									<div className="col-lg-10">
										<div className="header-content text-center">
											<h2 className="header-title2">CALL FOR PAPERS</h2>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="container">
					<p className="callforpapertext text-justify">
						Authors are cordially invited to contribute their original and
						unpublished research papers in the Internal Conference on
						Intelligent Systems and Human Machine Collaboration 2022.
						Contributions are solicited through online submission platform on
						the following (but not limited to) tracks –
					</p>
					<ol>
						<li className="callforpaperlist">
							Intelligent Human Machine Interaction
						</li>
						<li className="callforpaperlist">
							Internet-based intelligent information systems
						</li>
						<li className="callforpaperlist">
							Smart Sensor-based information networks
						</li>
						<li className="callforpaperlist">
							Wearable devices and information appliance design
						</li>
						<li className="callforpaperlist">
							Multimedia and multi-modal human-computer interface
						</li>
						<li className="callforpaperlist">
							Intelligent Multi-agent system design
						</li>
						<li className="callforpaperlist">
							Computer-assisted human-human interaction
						</li>
						<li className="callforpaperlist">
							Collaborative and interactive HCI systems
						</li>
						<li className="callforpaperlist">
							Affective and ubiquitous computing
						</li>
						<li className="callforpaperlist">
							Intelligent Data and Signal Processing
						</li>
						<li className="callforpaperlist">
							Quantum Computational Intelligence
						</li>
						<li className="callforpaperlist">Big Data Analytics and IoT</li>
					</ol>
				</div>

				{/* <div className="container callforpapertext-instruction">
					<p className="callforpapertext-title-semi">
						Instructions For Authors
					</p>
					<h5>
						The manuscript should be prepared following the guidelines of
						Springer Conference Proceedings
						<a href="https://www.springer.com/gp/authors-editors/conference-proceedings/conference-proceedings-guidelines">
							(https://www.springer.com/gp/authors-editors/conference-proceedings/conference-proceedings-guidelines).
						</a>
						The manuscripts should be submitted in PDF format.{" "}
					</h5> */}
				{/* <ol>
						{instructions &&
							instructions.map((a, key) => (
								<li className="callforpaperlist">{a}</li>
							))}
					</ol> */}
				{/* <div className="submit-paper-btn">
						<LinkButton2 label="Submit the Paper" link="/submit" />
					</div> */}
				{/* </div> */}

				{/* <div className="container callforpapertext-instruction">
          <p className="callforpapertext-title-semi">Copy Right Form</p>
          <p className="callforpapertext-2 ">
            In order to publish paper in the conference proceeding, the authors
            are required to submit a signed copyright form for each accepted
            paper during registration.
          </p>
        </div> */}
				{/* <div className="schedule-section row">
					<table className="annoucement-table container">
						<tr className="annoucement-table-header-row">
							<th>Deadline</th>
							<th>Dates</th>
						</tr>
						{callforpaper &&
							callforpaper.map((a, key) => (
								<tr className="announcement-table-row">
									<td className="annoucement-title">{a?.title}</td>
									<td dangerouslySetInnerHTML={{ __html: a?.date }} />
								</tr>
							))}
					</table>
				</div> */}
				{/* <div className="container callforpapertext-instruction">
					<p className="callforpapertext-title-semi">Paper Submission</p>
					<h5>
						Submission should be done through EasyChair Conference management
						portal using the link
						<a href="https://easychair.org/conferences/?conf=icishmc2022">
							https://easychair.org/conferences/?conf=icishmc2022.
						</a>
					</h5>
				</div> */}
			</>
		);
	}
}

export default CallForPapers;
